import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'shortStr'
})
export class ShortStrPipe implements PipeTransform {

  transform(str: string, limit: string): string | null {
    let limitNum = Number(limit);
    if(str == null || str == undefined){
      return null;
    } else if(str.length < limitNum){
      return str;
    } else if(str && limit){
      return str.substring(0, limitNum) + "...";
    }
    return null;
  }

}
